import { LOADING, FAILED, SUCCESS, RESET } from './constants';
import { listBusinessType, businessTypeUpdate, addBusinessType } from '../../utils/api';

export function fetchListBusinessType(params = {}, search = '') {
  return async (dispatch,getState) => {
    const state = getState();
    const KEY = 'BusinessType';
    // const { page, totalPage } = state.settingBusinessType.dataBusinessType.meta;
    const fetchedData = state?.settingBusinessType.dataBusinessType.data || [];
    try {
      dispatch(loadingAction(true, KEY));
      const { data, meta } = await listBusinessType({ ...params, search: search });
      const mergedData = params.page > 1 ?  [...fetchedData, ...data] : data;
      dispatch(successAction({ data: mergedData, meta }, KEY));
      clearRedux('SubmitAddBusinessType');
      clearRedux('UpdateBusinessType');
      clearRedux('DeleteBusinessType');
    } catch (error) {
      dispatch(failedAction(error.message, KEY));
    }
  };
}

export const postAddBusinessType = (payload, type) => {
  return async(dispatch) => {
    const key = 'SubmitAddBusinessType';
    try {
      dispatch(loadingAction(true, key));
      const data = await addBusinessType(payload, type);
      dispatch(successAction({ type, ...data }, key, payload.name || type));
    } catch (error) {
      dispatch(failedAction(error.message, key, { type, ...error }));
    }
  };
};

export function editBusinessType(payload) {
  return async (dispatch) => {
    const key = 'UpdateBusinessType';
    dispatch(loadingAction(true, key));
    try {
      await businessTypeUpdate(payload, 'PUT');
      dispatch(successAction({
        success: true,
        oldName: payload.oldName,
        ...payload
      }, key, 'success'));
      dispatch(loadingAction(false, key));
    } catch (error) {
      dispatch(loadingAction(false, key));
      dispatch(failedAction(error.message, key, { ...error }));
    }
  };
}

export function deleteBusinessType(payload) {
  return async(dispatch) => {
    const key = 'DeleteBusinessType';
    dispatch(loadingAction(true, key));
    try {
      await businessTypeUpdate(payload, 'DELETE');
      dispatch(successAction({
        success: true
      }, key, payload.name));
    } catch (error) {
      dispatch(successAction({
        success: false
      }, 'DeleteBusinessType'));
      dispatch(failedAction(error.message, key, {
        success: false,
        code: error.code
      }));
    }
  };
}

export const clearRedux = (key)  => {
  return async(dispatch) => {
    dispatch(reset(key));
  };
};

export function failedAction(message, key, data = false) {
  return { type: FAILED, message, key, data };
}

export function loadingAction(isLoading, key) {
  return { type: LOADING, isLoading, key };
}

export function successAction(data, key, message) {
  return { type: SUCCESS, data, key, message: message };
}

export function reset(key) {
  return { type: RESET, key };
}
